/** 角色类型 */
export const RoleType = {
    /** 骑手App */
    RIDER_APP: 'RIDER_APP',

    /** 顾客APP */
    USER_APP: 'USER_APP',

    /** 运营中心 */
    OPERATION_COMPANY: 'OPERATION_COMPANY'
};

export const RoleTypeDesc = {
    /** 骑手App */
    [RoleType.RIDER_APP]: '骑手端',

    /** 顾客APP */
    [RoleType.USER_APP]: '客户端',

    /** 运营中心 */
    [RoleType.OPERATION_COMPANY]: '运营公司'
};

/** 开启状态 */
export const State = {
    /** 开启 */
    start: 1,

    /** 关闭 */
    close: 0,

    '0': '已禁用',

    '1': '已启用'
};

/** 文章列表字段 */
export const ArticleFields = {
    /** 标题 */
    title: 'title',

    /** 排序 */
    sort: 'sortNo',

    /** 状态 */
    state: 'status',

    /** 状态 */
    stateDesc: 'statusValue'
};
